export default __webpack_public_path__ + "static/23-low-life-punk-9cadd5db3f67498470b28191ede80b02.png";